import ModelBuilder, { FormFieldsOf, Prefix } from 'helpers/ModelBuilder';

export type Address = {
  address: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
};

export const addressFields = ModelBuilder.buildFormFields<Address>({
  address: { label: 'Address' },
  address2: { label: 'Apt. Suite (Optional)' },
  city: { label: 'City' },
  state: { label: 'State/Province', type: 'searchable' },
  postalCode: { label: 'Zip/Postal Code', placeholder: 'Code' },
  country: { label: 'Country', type: 'searchable' },
});

export type BillingAddress = Prefix<Address, 'billing'>;

export const billingFields = ModelBuilder.prefixFields(addressFields, 'billing') as FormFieldsOf<BillingAddress>;
